
define('lib/require/less!css/style',[],function(){});
